export const role = {
  admin: "admin",
  student: "student",
  cordinator: "coordinator",
  delegate: "delegate",
  company: "company",
};
